// extracted by mini-css-extract-plugin
export var acitonButtons = "_id-0";
export var additionalIcon = "_id-f";
export var block = "_id-1";
export var blockContent = "_id-7";
export var blockDescription = "_id-8";
export var blockIcon = "_id-9";
export var blockTitle = "_id-6";
export var border = "_id-a";
export var center = "_id-l";
export var edge = "_id-b";
export var edgeLabel = "_id-c";
export var edgePath = "_id-d";
export var error = "_id-e";
export var flowchart = "_id-g";
export var flowchartContent = "_id-h";
export var highlighted = "_id-3";
export var hover = "_id-4";
export var icon = "_id-i";
export var left = "_id-m";
export var navButton = "_id-j";
export var navButtons = "_id-k";
export var right = "_id-n";
export var selected = "_id-2";
export var small = "_id-5";